/**
 * 查找对应板块的状态
 */

import {
  DECORATION_BACKGROUND,
  DECORATION_COUPON,
  DECORATION_EASY_CHAT,
  DECORATION_EVALUATE,
  DECORATION_EXAMPLE,
  DECORATION_GIFT,
  DECORATION_MEAL,
  DECORATION_MERCHANT_BANNER,
  DECORATION_MERCHANT_HONOR,
  DECORATION_MERCHANT_PROMISE,
  DECORATION_MERCHANT_UPDATES,
  DECORATION_MERCHANT_VIDEO,
  DECORATION_SHOP_INFO,
  DECORATION_STYLE_ALBUM,
  M_STATUS_REJECTED,
  M_STATUS_VERIFYING,
  PRIVILEGE_EASY_CHAT,
  PRIVILEGE_GIFT,
  PRIVILEGE_PROMISE_ID,
  PRIVILEGE_REFUND_ID,
  PRIVILEGE_STATUS_REJECTED,
  PRIVILEGE_STATUS_VERIFYING,
  PROMISE_STATUS_FAIL,
  PROMISE_STATUS_PADDING,
  SERVICE_CONFIG,
  VIDEO_STATUS_FAIL,
  VIDEO_STATUS_PADDING,
  DECORATION_MERCHANT_ACTIVITY,
  MerchantActivityStatus
} from '@constant'
import {
  AuditIconStatusEnum,
  ServiceConfigAuditEnum,
  ShopInfoAuditEnum
} from '../../../../../../constant/merchant/decorationStatus'

/**
 * @title 商家承诺状态
 */
const promiseStatus = allStatus => {
  const promise = allStatus?.privileges?.find(
    f => +f.id == PRIVILEGE_PROMISE_ID
  )
  const refund = allStatus?.privileges?.find(f => +f.id == PRIVILEGE_REFUND_ID)
  if (promise && refund) {
    if (
      promise.status == PROMISE_STATUS_PADDING ||
      refund.status == PROMISE_STATUS_PADDING
    ) {
      return 'verifying'
    } else if (
      promise.status == PROMISE_STATUS_FAIL ||
      refund.status == PROMISE_STATUS_FAIL
    ) {
      return 'rejected'
    }
  }
  return ''
}

/**
 * @title 商家背景状态
 */
const backgroundStatus = allStatus => {
  const textStatus = allStatus?.pending_data?.des?.status
  const photoStatus = allStatus?.pending_data?.real_photos?.status

  return textStatus == M_STATUS_REJECTED || photoStatus == M_STATUS_REJECTED
    ? 'rejected'
    : textStatus == M_STATUS_VERIFYING || photoStatus == M_STATUS_VERIFYING
      ? 'verifying'
      : ''
}

/**
 * @title 商家到店礼状态
 */
const giftStatus = allStatus => {
  const gift = allStatus?.privileges?.filter(f => +f.id === PRIVILEGE_GIFT)?.[0]

  if (gift) {
    if (gift.status == PRIVILEGE_STATUS_REJECTED) {
      return 'rejected'
    } else if (gift.status == PRIVILEGE_STATUS_VERIFYING) {
      return 'verifying'
    }
  }
  return ''
}

/**
 * @title 商家顶部配置
 */
const topVideoStatus = allStatus => {
  const merchant_video = allStatus?.merchant_video

  if (merchant_video) {
    if (merchant_video.status == VIDEO_STATUS_FAIL) {
      return 'rejected'
    } else if (merchant_video.status == VIDEO_STATUS_PADDING) {
      return 'verifying'
    }
  }
  return ''
}

/**
 * @title 聊天咨询状态
 */
const easyChatStatus = allStatus => {
  const chat = allStatus?.privileges?.filter(
    item => +item.id === PRIVILEGE_EASY_CHAT
  )?.[0]

  if (chat) {
    if (chat.status == PRIVILEGE_STATUS_REJECTED) {
      return 'rejected'
    } else if (chat.status == PRIVILEGE_STATUS_VERIFYING) {
      return 'verifying'
    }
  }

  return ''
}

/**
 * @title 店铺广告
 */
const merchantBannerStatus = allStatus => {
  const status = allStatus?.merchant_recommend_meal_status
  if (status == M_STATUS_VERIFYING) {
    return 'verifying'
  }
  if (status == '2') {
    return 'rejected'
  }
  return ''
}

/**
 * 店铺信息状态
 * @param allStatus
 */
const shopInfoStatus = allStatus => {
  const status = allStatus?.merchant_status
  if (status === ShopInfoAuditEnum.AUDIT) {
    return AuditIconStatusEnum.VERIFYING
  }
  if (status === ShopInfoAuditEnum.REJECTED) {
    return AuditIconStatusEnum.REJECTED
  }
  return AuditIconStatusEnum.SUCCESS
}

/**
 * 服务说明状态
 * @param allStatus
 */
const serviceConfigStatus = allStatus => {
  const status = allStatus?.service_config_status
  if (status === ServiceConfigAuditEnum.AUDIT) {
    return AuditIconStatusEnum.VERIFYING
  }
  if (status === ServiceConfigAuditEnum.REJECTED) {
    return AuditIconStatusEnum.REJECTED
  }
  return AuditIconStatusEnum.SUCCESS
}

//商家活动

const merchantActivityStatus = allStatus => {
  const status = allStatus?.merchant_activity?.status
  console.log(status)
  if (status === MerchantActivityStatus.AUDIT) {
    return AuditIconStatusEnum.VERIFYING
  }
  if (status === MerchantActivityStatus.REJECTED) {
    return AuditIconStatusEnum.REJECTED
  }
  return AuditIconStatusEnum.SUCCESS
}

export const findStatus = (allStatus, type) => {
  console.log(allStatus, type)
  const status = {
    [DECORATION_BACKGROUND]: backgroundStatus(allStatus),
    [DECORATION_MERCHANT_HONOR]: '',
    [DECORATION_MERCHANT_PROMISE]: promiseStatus(allStatus),
    [DECORATION_COUPON]: '',
    [DECORATION_GIFT]: giftStatus(allStatus),
    [DECORATION_MEAL]: '',
    [DECORATION_STYLE_ALBUM]: '',
    [DECORATION_MERCHANT_BANNER]: '',
    [DECORATION_MERCHANT_VIDEO]: topVideoStatus(allStatus),
    [DECORATION_EVALUATE]: '',
    [DECORATION_MERCHANT_UPDATES]: '',
    [DECORATION_EASY_CHAT]: easyChatStatus(allStatus),
    [DECORATION_EXAMPLE]: '',
    [DECORATION_MERCHANT_BANNER]: merchantBannerStatus(allStatus),
    [DECORATION_SHOP_INFO]: shopInfoStatus(allStatus),
    [SERVICE_CONFIG]: serviceConfigStatus(allStatus),
    [DECORATION_MERCHANT_ACTIVITY]: merchantActivityStatus(allStatus)
  }

  return status[type]
}
